"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralEnquiryDetailsDtoQueryEnum = void 0;
exports.instanceOfGeneralEnquiryDetailsDto = instanceOfGeneralEnquiryDetailsDto;
exports.GeneralEnquiryDetailsDtoFromJSON = GeneralEnquiryDetailsDtoFromJSON;
exports.GeneralEnquiryDetailsDtoFromJSONTyped = GeneralEnquiryDetailsDtoFromJSONTyped;
exports.GeneralEnquiryDetailsDtoToJSON = GeneralEnquiryDetailsDtoToJSON;
exports.GeneralEnquiryDetailsDtoToJSONTyped = GeneralEnquiryDetailsDtoToJSONTyped;
/**
 * @export
 */
exports.GeneralEnquiryDetailsDtoQueryEnum = {
    PropertyListing: 'property_listing',
    Campaign: 'campaign',
    AccountDelete: 'account_delete',
    Other: 'other'
};
/**
 * Check if a given object implements the GeneralEnquiryDetailsDto interface.
 */
function instanceOfGeneralEnquiryDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('query' in value) || value['query'] === undefined)
        return false;
    if (!('details' in value) || value['details'] === undefined)
        return false;
    return true;
}
function GeneralEnquiryDetailsDtoFromJSON(json) {
    return GeneralEnquiryDetailsDtoFromJSONTyped(json, false);
}
function GeneralEnquiryDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'query': json['query'],
        'details': json['details'],
        'listingId': json['listingId'] == null ? undefined : json['listingId'],
    };
}
function GeneralEnquiryDetailsDtoToJSON(json) {
    return GeneralEnquiryDetailsDtoToJSONTyped(json, false);
}
function GeneralEnquiryDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'query': value['query'],
        'details': value['details'],
        'listingId': value['listingId'],
    };
}
